import { mdiWebcam } from '@mdi/js';
import Icon from '@mdi/react';
import { palette } from '../../../../components/styles/colors';
import { locales } from '../../../../locales/en';
import "./MinimizeUserBroadcastConfirmation.linaria.module.css!=!./MinimizeUserBroadcastConfirmation?./MinimizeUserBroadcastConfirmation.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNTy+MTytJz8wx0kPhVecmFqVn5ukm5ZeU5OdaWRRUWNdygZUkW8QbppVX5JWlonGr0/LzSnSLM6tSrQyNUNQXpeRnlVqg8pBUWyIUpxfGGxqlFycapKBx0dyjC7EAAITKgMPCAAAA"
const stylesWarningHideBroadcast = "atm_gq_ftgil2 atm_c8_1fwxnve";
const stylesUnhideBroadcast = "atm_c8_rdoju8";
const stylesUnhideBroadcastIcon = "atm_gq_12gsa0d";
const MinimizeUserBroadcastConfirmation = () => <div>
        <div>{locales.userBroadcast.confirmationHideBroadcast}</div>
        <br />
        <div className={stylesWarningHideBroadcast}>
            {locales.userBroadcast.warningHideBroadcast}
        </div>
        <div className={stylesUnhideBroadcast}>
            {locales.userBroadcast.unhideBroadcast1}{' '}
            <Icon className={stylesUnhideBroadcastIcon} color={palette.secondary} path={mdiWebcam} size={0.6} />{' '}
            {locales.userBroadcast.unhideBroadcast2}
        </div>
    </div>;
export default MinimizeUserBroadcastConfirmation;